/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { PropTypes } from "prop-types";
import DropDown from "component-library/dropDown";
import FormTooltip from "component-library/inputFields/FormTooltip";
import classNames from "classnames/bind";
import Toaster from "component-library/toasters";
import * as FIELDS from "./Constants";
console.log(FIELDS);

const getYearList = () => {
  let yearList = [];
  for (let i = 1980; i <= 2050; i++) {
    yearList.push({
      id: i,
      value: i,
      label: `${i}`
    });
  }
  return yearList;
};

const options = {
  FromMonths: [
    { id: 1, value: 1, label: "January" },
    { id: 2, value: 2, label: "February" },
    { id: 3, value: 3, label: "March" },
    { id: 4, value: 4, label: "April" },
    { id: 5, value: 5, label: "May" },
    { id: 6, value: 6, label: "June" },
    { id: 7, value: 7, label: "July" },
    { id: 8, value: 8, label: "August" },
    { id: 9, value: 9, label: "September	" },
    { id: 10, value: 10, label: "October" },
    { id: 11, value: 11, label: "November" },
    { id: 12, value: 12, label: "December" }
  ],
  FromYear: getYearList()
};

const labelMaker = (noLabel, allLabel, someLabel, oneLabel) => (o, s, all) =>
  all
    ? allLabel
    : Object.keys(s).filter(k => s[k]).length === 0
    ? noLabel
    : Object.keys(s).filter(k => s[k]).length === 1
    ? oneLabel
    : someLabel;

class MonthYear extends Component {
  state = { showTooltip: false };
  showTooltipHandler = () => {
    this.setState({
      showTooltip: !this.state.showTooltip
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.setState({
        showTooltip: false
      });
    }
  }

  render() {
    const { props } = this;
    const { Month, Year, errors } = props;

    let lgClass = "col-lg-4";
    let mdClass = "col-md-6";
    let smClass = "col-sm-12";
    let xsClass = "col-xs-12";
    if (props.Size) {
      if (props.Size.length > 0) {
        lgClass = props.Size[0] && "col-lg-" + props.Size[0];
        mdClass = props.Size[1] && "col-md-" + props.Size[1];
        smClass = props.Size[2] && "col-sm-" + props.Size[2];
        xsClass = props.Size[3] && "col-xs-" + props.Size[3];
      }
    }

    let wrapperClass;
    if (props.class === undefined) {
      wrapperClass = "nc-field-group clearfix";
    } else {
      wrapperClass = "nc-field-group " + props.class + " clearfix";
    }
    let error = "";
    if ((errors[Month] || errors[Year]) && props.required) {
      wrapperClass = wrapperClass + " has-error " + props.inputName;
      error = "This is a required field.";
    }
    const InputFieldClass = classNames(
      props.className,
      lgClass,
      mdClass,
      smClass,
      xsClass
    );
    return (
      <div>
        <div
          className={wrapperClass}
          style={{ clear: "both", display: "flex", alignItems: "center" }}
        >
          {props.Toaster && props.Toaster.show && (
            <Toaster
              show={props.Toaster.show}
              alertClassName={props.Toaster.type}
              message={props.Toaster.content}
            />
          )}
          <div
            id={"label" + props.inputName}
            style={{ paddingRight: "15px" }}
            className={"col-lg-3 col-md-3 col-sm-3 field-name clearfix"}
          >
            {props.label}{" "}
            {props.optional && <i className="optional-field">(Optional) </i>}{" "}
            {props.tooltip && (
              <a onClick={this.showTooltipHandler}>
                <i className="fa fa-info-circle" />
              </a>
            )}
          </div>
          <div
            className="dates-container col-lg-6 col-md-6 col-sm-6 col-xs-12"
            style={{
              width: "45%",
              marginBottom: "20px"
            }}
          >
            {" "}
            <div
              style={{
                clear: "both",
                display: "flex",
                alignItems: "center"
              }}
            >
              <DropDown
                options={options.FromMonths}
                value={parseInt(props.data[Month], 10)}
                id={"dd-from-months"}
                className={InputFieldClass}
                makeLabel={labelMaker(
                  FIELDS.MonthYear["months"][0],
                  FIELDS.MonthYear["months"][1],
                  FIELDS.MonthYear["months"][2],
                  FIELDS.MonthYear["months"][3]
                )}
                onSelect={e =>
                  props.onChange &&
                  props.onChange({
                    name: Month,
                    value: e
                  })
                }
              />
              <DropDown
                options={options.FromYear}
                value={parseInt(props.data[Year], 10)}
                id={"dd-from-year"}
                className={InputFieldClass}
                makeLabel={labelMaker(
                  FIELDS.MonthYear["year"][0],
                  FIELDS.MonthYear["year"][1],
                  FIELDS.MonthYear["year"][2],
                  FIELDS.MonthYear["year"][3]
                )}
                onSelect={e =>
                  props.onChange &&
                  props.onChange({
                    name: Year,
                    value: e
                  })
                }
              />
            </div>
            {error && props.required && (
              <div
                style={{ marginTop: "5px", fontSize: "15px" }}
                className="has-error"
              >
                {error}
              </div>
            )}
          </div>
        </div>
        <div className={"col-lg-offset-3 col-md-offset-3"}>
          {this.state.showTooltip && props.tooltip && (
            <FormTooltip
              onCloseHandler={this.showTooltipHandler}
              content={props.tooltip}
              width={props.tooltipwidth}
            />
          )}
        </div>
      </div>
    );
  }
}

export default MonthYear;
MonthYear.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.string
};

MonthYear.defaultProps = {
  descriptionStyle: "",
  hideTopdescription: false,
  colSpan: ""
};
